module.exports = __webpack_public_path__ + "static/media/icloud.2b25a368.png";